module.exports = __webpack_public_path__ + "static/media/1009963.a0a78125.jpg";